module.exports = __webpack_public_path__ + "static/media/interview_transcript.4ecac877.png";